import { Paragraph, type ParagraphOptions } from '@tiptap/extension-paragraph'
import { mergeAttributes } from '@tiptap/core'

export enum Paragraphs {
  BIG_TEXT = 'bigText',
  NORMAL_TEXT = 'normalText',
  SMALL_TEXT = 'smallText',
}

export const DEFAULT_FONT_SIZE = 14

export const styling: { [k in Paragraphs]: { class: string; fontSize: number } } = {
  [Paragraphs.BIG_TEXT]: {
    class: 'font-400 c-theme-preset c-theme-preset--big_text',
    fontSize: 24,
  },
  [Paragraphs.NORMAL_TEXT]: {
    class: 'font-400 c-theme-preset c-theme-preset--normal_text',
    fontSize: DEFAULT_FONT_SIZE,
  },
  [Paragraphs.SMALL_TEXT]: {
    class: 'font-400 c-theme-preset c-theme-preset--small_text',
    fontSize: 12,
  },
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    paragraphExtended: {
      setParagraphExtended: (size: string) => ReturnType
    }
  }
}

export interface ParagraphOptionsExtended extends ParagraphOptions {
  sizes: Paragraphs[]
}

export const ParagraphExtended = Paragraph.extend<ParagraphOptionsExtended, any>({
  addOptions() {
    return {
      ...this.parent?.(),
      sizes: [Paragraphs.SMALL_TEXT, Paragraphs.NORMAL_TEXT, Paragraphs.BIG_TEXT],
    }
  },

  addAttributes() {
    return {
      size: {
        parseHTML: (element) => element.getAttribute('data-size'),
        default: Paragraphs.NORMAL_TEXT,
        rendered: false,
        renderHTML: (attributes) => {
          return {
            'data-size': attributes.size,
          }
        },
      },
    }
  },

  parseHTML() {
    return [{ tag: 'p' }]
  },

  addCommands() {
    return {
      setParagraphExtended:
        (size) =>
        ({ commands }) =>
          commands.setNode(this.name, { size }),
    }
  },

  renderHTML({ node, HTMLAttributes }) {
    const classes = styling[(node.attrs.size as Paragraphs) ?? Paragraphs.NORMAL_TEXT].class

    return [
      'p',
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
        class: classes,
        'data-size': node.attrs.size,
      }),
      0,
    ]
  },
})

export default ParagraphExtended
